import { Controller, useFormContext } from "react-hook-form";

import ComboBoxDefaultItem from "ds/components/ComboBox/DefaultItem";
import ComboBox from "ds/components/ComboBox";

type AttachCloudFormIntegrationFieldProps = {
  options: Array<{ label: string; value: string }>;
};

const AttachCloudFormIntegrationField = ({ options }: AttachCloudFormIntegrationFieldProps) => {
  const { control } = useFormContext<{ integrationId: string }>();
  return (
    <Controller
      name="integrationId"
      rules={{ required: "Integration is required" }}
      control={control}
      render={({ field, fieldState }) => (
        <ComboBox
          label="Attach integration"
          value={field.value}
          items={options}
          onChange={field.onChange}
          error={fieldState.error?.message}
        >
          {(item) => <ComboBoxDefaultItem id={item.value} label={item.label} />}
        </ComboBox>
      )}
    />
  );
};

export default AttachCloudFormIntegrationField;
